<template>
  <i-modal
    :title="$t(edit ? 'editing' : 'add', { value: $tc('roles', 1) })"
    :value="value"
    :field-value.sync="roles.name"
    :load="loading"
    @submit="submit"
    @input="$emit('input', $event)"
  >
  </i-modal>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    toEdit: {
      type: [Object],
      default: () => null
    }
  },
  data() {
    return {
      isLoading: false,
      loading: false,
      roles: {
        name: ''
      },
      edit: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          this.edit = this.toEdit !== null
          this.roles = this.toEdit !== null ? { ...this.toEdit } : { name: '' }
        }
      }
    }
  },
  methods: {
    async submit() {
      if (!this.loading) {
        try {
          this.loading = true
          !this.edit
            ? await this.$api.role.create({
                form: this.roles
              })
            : await this.$api.role.edit({
                pk: this.roles.pk,
                form: this.roles
              })
          this.$emit('done')
          this.$emit('input', false)
          this.$toast.success(
            `${this.$tc('roles', 1)} ${this.$tc(
              this.edit ? 'edited' : 'created',
              1
            )}`
          )
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>
